import getConfig from 'next/config';
import QueryString from 'qs';
import { Order, OrderPaymentInstrument } from '~/lib/data-contract/salesforce';

const { publicRuntimeConfig } = getConfig() || {};

// TODO: Marry createAbsoluteUrl functions in url.ts.
export const createAbsoluteUrl = (relativeUrl: string, baseUrl?: string) =>
    new URL(relativeUrl, baseUrl || publicRuntimeConfig.NEXT_PUBLIC_URL);

export const createAltaPayCallbackUrl = (parameters: {
    orderNo: string | undefined;
    sessionId?: string;
    redirectData?: string;
}) => {
    const url = new URL('/altapay/callback', publicRuntimeConfig.NEXT_PUBLIC_URL);

    url.search = QueryString.stringify(parameters);

    return url;
};

export const extractPaymentInstrumentByMethod = (
    paymentInstruments: OrderPaymentInstrument[] | undefined,
    paymentMethodId: string,
) => {
    const paymentInstrument = paymentInstruments?.find(
        (instrument) => instrument.paymentMethodId === paymentMethodId,
    );

    return paymentInstrument;
};

export const clientRedirect = (params: { targetUrl: string | URL; returnUrl?: string | URL }) => {
    if (typeof window === 'undefined') return;

    const { targetUrl, returnUrl } = params;

    const destination = typeof targetUrl === 'string' ? targetUrl : targetUrl.toString();

    if (window.top === window.self) {
        if (returnUrl) window.history.replaceState(null, '', returnUrl);

        window.location.href = destination;
    } else if (window.top) {
        if (returnUrl) window.top.history.replaceState(null, '', returnUrl);

        window.top.location.href = destination;
    }
};

export const finalizeOrder = (orderNumber: string, basketId: string, basketTotal?: number) => {
    if (!orderNumber || !basketId) {
        throw new Error('Missing "orderNumber" and "basketId" are required.');
    }

    const request = fetch('/api/salesforce/custom/createOrderWithId', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            orderNo: orderNumber,
            basketId,
            basketTotal,
        }),
    });

    return request
        .then((response) => {
            if (!response.ok) throw response;

            return response.json();
        })
        .then((data) => {
            /**
             * For some reason, 'false' is returned by our createOcapiFetch function when
             * it experiences 401 errors. We'll handle it accordingly.
             */
            if (data === false) {
                throw new Error('SFCC (createWithOrderId): 401 Unauthorized');
            }

            return data as Order;
        });
};

export const isOrder = (value: unknown): value is Order =>
    typeof value === 'object' && value !== null && 'orderNo' in value && !!value.orderNo;
